export const
    ACHIEVEMENTS_PENDING = 'achievements_pending',
    ACHIEVEMENTS_FAILED = 'achievements_failed',
    ACHIEVEMENTS_DOWNLOADED = 'achievements_downloaded',
    ACHIEVEMENT_DOWNLOADED = 'achievement_downloaded',
    ACHIEVEMENT_DELETING = 'achievement_deleting',
    ACHIEVEMENT_DELETED = 'achievement_deleted',
    ACHIEVEMENT_EDITING = 'achievement_editing',
    ACHIEVEMENT_RESET = 'achievement_reset',
    ACHIEVEMENT_POSTING = 'achievement_posting',
    ACHIEVEMENT_PICTURE_UPLOADING = 'achievement_picture_uploading',
    ACHIEVEMENT_PICTURE_FAILED = 'achievement_picture_failed',
    ACHIEVEMENT_UNEARNED_PICTURE_UPLOADING = 'achievement_unearned_picture_uploading',
    ACHIEVEMENT_UNEARNED_PICTURE_FAILED = 'achievement_unearned_picture_failed';



// WEBPACK FOOTER //
// src/store/achievements/types.js